import React, { useState, useRef, useEffect } from 'react';
import { FaHiking, FaWater, FaParachuteBox, FaCampground } from 'react-icons/fa';
import { GiDeer } from 'react-icons/gi';
import { Link } from 'react-router-dom';
import '../Serve2/Serve2.css';

const tourTypes = [
  { id: 1, title: 'Adventure Trek', icon: <FaHiking />, description: 'Explore thrilling hiking adventures around the world.' },
  { id: 2, title: 'Windsurfing Fun', icon: <FaWater />, description: 'Ride the waves and enjoy exciting windsurfing experiences.' },
  { id: 3, title: 'Paragliding High', icon: <FaParachuteBox />, description: 'Soar the skies with our guided paragliding tours.' },
  { id: 4, title: 'Wildlife Safari', icon: <GiDeer />, description: 'Discover nature and wildlife in their natural habitat.' },
  { id: 5, title: 'Hang Gliding Camp', icon: <FaCampground />, description: 'Fly freely and camp under the stars with us.' },
];

const Serve2 = () => {
  const [activeId, setActiveId] = useState(2);
  const containerRef = useRef(null);
  const indexRef = useRef(1);

  useEffect(() => {
    const interval = setInterval(() => {
      indexRef.current = (indexRef.current + 1) % tourTypes.length;
      setActiveId(tourTypes[indexRef.current].id);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    const activeCard = container?.querySelector('.card-s2.active-s2');
    if (container && activeCard) {
      const containerRect = container.getBoundingClientRect();
      const cardRect = activeCard.getBoundingClientRect();
      const offset = cardRect.left - containerRect.left - container.clientWidth / 2 + cardRect.width / 2;
      container.scrollBy({ left: offset, behavior: 'smooth' });
    }
  }, [activeId]);

  return (
    <section className="full-serve2">
      <div className="serve-section-s2">
        <div className="serve-container-s2">
          <div className="serve-content-s2">
            <p className="serve-label-s2">SERVICES</p>
            <h1 className="serve-heading-s2">
                Start Your Journey with our options
            </h1>
          </div>

          <div className="cards-wrapper-s2">
            <div className="cards-container-s2" ref={containerRef}>
              {tourTypes.map((type, index) => (
                <div
                  key={type.id}
                  className={`card-s2 ${activeId === type.id ? 'active-s2' : ''}`}
                  onClick={() => {
                    setActiveId(type.id);
                    indexRef.current = index;
                  }}
                >
                  <div className="card-number-s2">{String(index + 1).padStart(2, '0')}</div>
                  <div className="card-icon-s2">{type.icon}</div>
                  <h3>{type.title}</h3>
                  <p>{type.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

       
      </div>
       <div className="connect-box-s2">
          <h1 className="connect-heading-s2">
            Travel is a World Leading Online Tour<br />Booking Platform
          </h1>
          <Link to="/contactus">
          <button className="connect-button-s2">Book Now</button>
          </Link>
        </div>
    </section>
  );
};

export default Serve2;